exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".linear[data-v-2a3887c0]{position:absolute;top:-12px;z-index:1}#compose-fab[data-v-2a3887c0]{position:absolute;bottom:9px;right:8px}", "", {"version":3,"sources":["/Users/markryan/develop/personal/fresh-start/src/components/members/feedbackView.vue"],"names":[],"mappings":"AACA,yBACE,kBAAmB,AACnB,UAAW,AACX,SAAW,CACZ,AACD,8BACE,kBAAmB,AACnB,WAAY,AACZ,SAAW,CACZ","file":"feedbackView.vue","sourcesContent":["\n.linear[data-v-2a3887c0] {\n  position: absolute;\n  top: -12px;\n  z-index: 1;\n}\n#compose-fab[data-v-2a3887c0] {\n  position: absolute;\n  bottom: 9px;\n  right: 8px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a3887c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/members/feedbackView.vue
// module id = 637
// module chunks = 5